import { Injectable } from '@angular/core';

/**
 * Holds the Purchase Order + Implementation Agreement PDFs (captured on the PO panel
 * as base64 data-URIs) in localStorage so they survive the Stripe redirect and can be
 * uploaded from the activation page once the subscription is activated.
 */
@Injectable({ providedIn: 'root' })
export class PurchaseOrderReceiptStore {
  private static readonly PO_KEY = 'poReceiptPdf';
  private static readonly IMPL_KEY = 'implementationAgreementPdf';

  setPurchaseOrder(dataUri: string): void {
    localStorage.setItem(PurchaseOrderReceiptStore.PO_KEY, dataUri);
  }

  setImplementationAgreement(dataUri: string): void {
    localStorage.setItem(PurchaseOrderReceiptStore.IMPL_KEY, dataUri);
  }

  getPurchaseOrder(): string | null {
    return localStorage.getItem(PurchaseOrderReceiptStore.PO_KEY);
  }

  getImplementationAgreement(): string | null {
    return localStorage.getItem(PurchaseOrderReceiptStore.IMPL_KEY);
  }

  clear(): void {
    localStorage.removeItem(PurchaseOrderReceiptStore.PO_KEY);
    localStorage.removeItem(PurchaseOrderReceiptStore.IMPL_KEY);
  }
}
